query SearchGeometryTypes(
    $term: String!
) {
    searchGeometryTypes(
        term: $term
    ) {
        id

        name(language: "en") {
            text
        }
    }
}
